'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _cms = require('actions/cms');

var _Work = require('components/Work/Work');

var _Work2 = _interopRequireDefault(_Work);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Work
 *
 */
var mapStateToProps = function mapStateToProps(state) {
  var data = state.cms.projects;
  var loading = state.cms.loading;

  var projects = [];

  if (data !== null) {
    data.map(function (project) {
      var fields = [];
      var technicalFields = [];
      var type = project.getText('project.type');

      if (type === 'technical') {
        if (project.getGroup('project.technical-fields')) {
          project.getGroup('project.technical-fields').toArray().map(function (item) {
            var field = item.getText('technical-field');
            technicalFields.push({ field: field.toLowerCase() });
          });
        }
      } else {
        if (project.getGroup('project.fields')) {
          project.getGroup('project.fields').toArray().map(function (item) {
            var field = item.getText('field');
            fields.push({ field: field.toLowerCase() });
          });
        }
      }

      projects.push({
        position: project.getNumber('project.position'),
        title: project.getText('project.title'),
        subtitle: project.getStructuredText('project.subtitle').asHtml(),
        strap: project.getStructuredText('project.strap').asHtml(),
        client: project.getStructuredText('project.client').asHtml(),
        year: project.getNumber('project.year'),
        slug: project.uid,
        type: project.getText('project.type'),
        mainImage: project.getImage('project.main-image').url,
        fields: fields,
        technicalFields: technicalFields
      });
    });
  }

  var sortedProjects = _lodash2.default.sortBy(projects, function (o) {
    return o.position;
  });

  return {
    loading: loading,
    data: data,
    projects: sortedProjects
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
  return {
    fetchProjects: function fetchProjects(type, item, options) {
      dispatch((0, _cms.fetchProjects)(type, item, options));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Work2.default);


//////////////////
// WEBPACK FOOTER
// ./src/containers/Work.js
// module id = 353
// module chunks = 1